import { motion } from "framer-motion";
import { Users, Mail, TrendingUp, Eye } from "lucide-react";
import { MetricCard } from "@/components/admin/dashboard/MetricCard";
import { AnalyticsChart } from "@/components/admin/dashboard/AnalyticsChart";
import { TopArticles } from "@/components/admin/dashboard/TopArticles";
import { ActivityFeed } from "@/components/admin/dashboard/ActivityFeed";
import { QuickActions } from "@/components/admin/dashboard/QuickActions";

const metrics = [
  {
    title: "Total Subscribers",
    value: "12,847",
    change: "+12.5%",
    trend: "up" as const,
    icon: Users,
    color: "blue",
  },
  {
    title: "Average Open Rate",
    value: "68.2%",
    change: "+3.1%",
    trend: "up" as const,
    icon: Mail,
    color: "green",
  },
  {
    title: "Monthly Revenue",
    value: "$24,580",
    change: "+8.3%",
    trend: "up" as const,
    icon: TrendingUp,
    color: "purple",
  },
  {
    title: "Page Views Today",
    value: "8,432",
    change: "-2.4%",
    trend: "down" as const,
    icon: Eye,
    color: "orange",
  },
];

export default function Dashboard() {
  return (
    <div className="space-y-8">
      <div>
        <motion.h1
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-semibold tracking-tight"
        >
          Dashboard
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="text-muted-foreground mt-1"
        >
          Welcome back! Here's what's happening with Allen Analysis.
        </motion.p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {metrics.map((metric, index) => (
          <MetricCard key={metric.title} metric={metric} index={index} />
        ))}
      </div>

      <QuickActions />

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <AnalyticsChart />
        </div>
        <div className="lg:col-span-1">
          <ActivityFeed />
        </div>
      </div>

      <TopArticles />
    </div>
  );
}
